import { ColorBar, type ColorBarVariant } from '../UI';
import { getLocationColor, type LocationColorId } from '../../constants/locationColors';

interface LocationColorLineProps {
  // Resolved by resolveLocationColorId on the caller's side: the colour saved on
  // the locations settings page, or the name-derived default when none is.
  colorId: LocationColorId;
  // Passed through to ColorBar. Defaults to the hairline; the overview's cards
  // want 'block', the solid marker for a single-line heading.
  variant?: ColorBarVariant;
}

// Turns a center's colour identity into its colour accent, so the trigger and the
// menu rows share one place that knows how a location's colour becomes chrome.
export const LocationColorLine = ({ colorId, variant }: LocationColorLineProps) => (
  <ColorBar color={getLocationColor(colorId).base} variant={variant} />
);
